import { normalizeTemplate } from '@/utils/templates'
import { normalizeComponentResource } from '@/utils/component-resources'
import { readPageProject, snapshotPages } from '@/schema/page-project'
import { createTemplateSnapshot, createPageTemplateSnapshot, createProjectTemplateSnapshot, allTemplateLeaves } from './component-template'
import { templatePreviewNodes } from '@/runtime/template-preview'

function templatePageModel (template, defaults, nodes = template.snapshot.nodes) {
  if (template.kind === 'project') {
    const snapshot = template.snapshot
    const pages = snapshot.pages.map(page => ({ ...page, config: { ...page.config, name: page.name }, nodes: nodes ? templatePreviewNodes(page.nodes) : page.nodes }))
    const record = { id: template.id, name: template.name, metadata: { pageProject: { version: 1, homePageId: snapshot.homePageId, pages } } }
    return { ...readPageProject(record, defaults), template }
  }
  const component = template.kind === 'component'
  const config = component ? { width: template.snapshot.width, height: template.snapshot.height, backgroundColor: defaults.backgroundColor || '#1e1f1e' } : template.snapshot.config
  const page = { id: component ? 'template-component' : 'template-page', name: template.name.slice(0, 60), config: { ...config, name: template.name.slice(0, 60) }, nodes }
  const record = { id: template.id, name: template.name, metadata: { pageProject: { version: 1, homePageId: page.id, pages: [page] } } }
  return { ...readPageProject(record, defaults), template }
}

// 查询权限即可预览，包括他人公开的只读模板。
export function readTemplatePreview (value, defaults = {}) {
  const template = value.resourceType === 'component' ? normalizeComponentResource(value) : normalizeTemplate(value)
  return templatePageModel(template, defaults, template.kind === 'project' ? true : templatePreviewNodes(template.snapshot.nodes))
}

// 复用画布模型，但记录只属于模板，保存不调用大屏项目接口。
export function readTemplateEditor (value, defaults = {}) {
  const template = value.resourceType === 'component' ? normalizeComponentResource(value) : normalizeTemplate(value)
  if (!template.editable) throw new Error('当前模板不可编辑')
  allTemplateLeaves(template.snapshot).forEach(node => {
    if (template.kind !== 'component' && ['productList', 'deviceList'].includes(node.component.name)) {
      if (node.option.templateListSource === undefined) node.option.dataSource = 'platform'
      delete node.option.templateListSource
    }
  })
  return templatePageModel(template, defaults)
}

export function templateEditorPayload (template, config, nodes, project, activePageId) {
  const previous = normalizeTemplate(template)
  if (!previous.editable) throw new Error('当前模板不可编辑')
  const snapshot = previous.kind === 'component' ? createTemplateSnapshot(nodes) : previous.kind === 'project' ? createProjectTemplateSnapshot(snapshotPages(project, activePageId, config, nodes)) : createPageTemplateSnapshot(config, nodes)
  return { name: previous.name, description: previous.description, catalogIds: previous.catalogIds.slice(), visibility: previous.visibility,
    revision: previous.revision, snapshot: JSON.stringify(snapshot) }
}

export function templateRouteKind (name) {
  if (name === 'component-resource-edit') return 'component'
  const match = /^template-(component|page|project)-(edit|preview)$/.exec(name || '')
  return match ? match[1] : null
}
